"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollaborateButtonPanel = void 0;
var react_1 = __importStar(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var react_transition_group_1 = require("react-transition-group");
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ResourceTypes_1 = require("@CommonFrontendBackend/Resources/ResourceTypes");
var ShareResourceComponent_1 = require("Common/ShareResourceComponent/ShareResourceComponent");
var SharePageViewStore_1 = require("Common/ShareResourceComponent/ViewStore/SharePageViewStore");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var utils_2 = require("@qwilr/kaleidoscope/utils");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var containerClasses = (0, BemBuilder_1.default)("collaborate-button-container");
var CollaborateButtonPanel = function (props) {
    var _a;
    var _b = __read((0, react_1.useState)(false), 2), showPanel = _b[0], setShowPanel = _b[1];
    var sharePageViewStore = new SharePageViewStore_1.SharePageViewStore(props.rootDataStore, props.projectStore);
    var onClickOutside = new utils_2.OnClickOutside([".collaborate-button-container", ".reset-popover", ".tour-prompt", ".nested-portal"], function () {
        setShowPanel(false);
    });
    var toggleVisibility = function () {
        if (showPanel) {
            onClickOutside.stopListening();
        }
        else {
            onClickOutside.startListening();
        }
        setShowPanel(!showPanel);
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)((_a = {},
            _a[containerClasses()] = true,
            _a[containerClasses("", "disabled")] = props.disabled,
            _a)) },
        react_1.default.createElement(kaleidoscope_1.Tooltip, { size: kaleidoscope_1.TooltipSize.Large, content: react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "text-context-label space-stack-s" }, "Add Collaborators"),
                react_1.default.createElement("p", null, "Click here to add collaborators and teams to edit and review this page.")) },
            react_1.default.createElement(kaleidoscope_1.Button, { className: "collaborate-button prompt-target--collaborate", type: kaleidoscope_1.ButtonType.Secondary, onClick: toggleVisibility, disabled: props.disabled },
                react_1.default.createElement(icons_1.Team, null),
                "Collaborate")),
        react_1.default.createElement(react_transition_group_1.Transition, { mountOnEnter: true, unmountOnExit: true, onEnter: utils_1.forceReflow, in: showPanel, timeout: kaleidoscope_2.AnimationDuration.Medium }, function (transitionStatus) { return (react_1.default.createElement("div", { className: (0, classnames_1.default)("share-resource", "share-resource--".concat(transitionStatus)) },
            react_1.default.createElement(ShareResourceComponent_1.ShareResourceComponent, { inviteNewUserModal: props.inviteNewUserModal, resourceId: props.projectStore._id, resourceViewStore: sharePageViewStore, userDataStore: props.rootDataStore.userDataStore, telemetry: props.telemetry, userInvitePermission: props.rootDataStore.getAccountDataStore().getUserInvitePermission(), modal: props.modal, resourceType: ResourceTypes_1.DashboardResourceType.Page, ownerUserId: props.projectStore.user, adminsHavePrivilege: true, projectStore: props.projectStore, showCollaboratorLink: true }))); })));
};
exports.CollaborateButtonPanel = CollaborateButtonPanel;
